'use strict';

var callDateSet = require('../../common/internal/callDateSet');

function setDate(d, val) {
  callDateSet(d, 'Date', val);
}

module.exports = setDate;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/setDate.js
// module id = 51
// module chunks = 0